interface Props {
	className?: string;
	title?: string;
}

// Google Calendar brand mark (multicolor). Used as a small status indicator.
export function GoogleCalendarIcon({ className, title }: Props) {
	return (
		<img src="/google-calendar.png" className={className} title={title} />
	);
}
